import Issuer from "./Issuer";
import Transporter from "./Transport/List";

import Settings from "./Config/ConfigInForm";

import List2 from "./List/index2";

import BatchNFe from "./BatchNFe";

export const paths = [
  {
    path: "/nfe/issuer",
    component: Issuer,
  },
  {
    path: "/nfe/list",
    component: List2,
  },
  {
    path: "/nfe/settings",
    component: Settings,
  },
  {
    path: "/nfe/transporter",
    component: Transporter,
  },
  ,
  {
    path: "/nfe/export",
    component: BatchNFe,
  },
];
export const NFeRouters = {
  icon: "receipt",
  path: "/nfe/list",
  testId: "",
  label: "NF-e",
  tree: [
    {
      testId: "",
      icon: "file-invoice",
      path: "/nfe/issuer",
      label: "Emitir Nota",
    },
    {
      testId: "",
      icon: "list",
      path: "/nfe/list",
      label: "Notas Emitidas",
    },
    {
      testId: "",
      icon: "file-export",
      path: "/nfe/export",
      label: "Exportar XML em Lote ",
    },
    {
      testId: "",
      icon: "shuttle-van",
      path: "/nfe/transporter",
      label: "Transportadora(s)",
    },
    {
      testId: "",
      icon: "cog",
      path: "/nfe/settings",
      label: "Configurações",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/routers.js